import React, { useEffect, useState } from "react";
import { inquiry } from "@Api";
import cx from "classnames";
import { logEvent } from "@Lib/analytics";
import Refresh from "../../components/ask/Refresh";
import { RegionsNavProps, ShowroomsData } from "@Types/business";
import { RegionItem, SelectItem, Tag, ShowroomItem } from "@t8891/pc-trial";
import styles from "./index.module.less";

const { fetchBusinessRegionsNav, fetchBusinessShowrooms } = inquiry;

interface IProps {
  type: string;
}

const Showroom: React.FC<IProps> = ({ type }) => {
  const source = type === "sum" ? "綜述頁-下方展示間" : "展示間列表";
  const [sort, setSort] = useState<"default" | "agent" | "user">("default");
  const [data, setData] = useState<ShowroomsData>({
    list: [],
    total: 0,
  });
  const [regionData, setRegion] = useState<RegionsNavProps>({
    selectedId: 0,
    list: {},
    hot: [],
  });
  const [item, setItem] = useState({ id: 0, name: "" });
  const [active, setActive] = useState(false);

  const fetchRegion = async () => {
    const res: { data; status } = await fetchBusinessRegionsNav({
      type: "showroom",
      brandId: window.brandId,
      limit: 8,
    });

    if (res.status === 12000) {
      setRegion(res.data);
    }
  };

  const fetchData = async (params) => {
    const res: { data; status } = await fetchBusinessShowrooms(params);
    if (res.status === 12000) {
      setData(res.data);
    }
  };

  useEffect(() => {
    window.brandId !== "" && fetchRegion();
  }, [window.brandId]);

  useEffect(() => {
    if (regionData.selectedId !== 0) {
      setItem({ id: regionData.selectedId, name: "" });
    }
  }, [regionData]);

  useEffect(() => {
    if (item.id !== 0) {
      fetchData({
        region: item.id,
        sort: sort,
        brandId: window.brandId,
        kindId: window.kindId,
        limit: type === "sum" ? 20 : 100,
      });
    }
  }, [sort, item.id]);

  return (
    <section className={styles["Showroom"]}>
      <SelectItem
        className={styles["select-region"]}
        size='small'
        active={active}
        selected={item}
        data={regionData.hot}
        title='地區'
        onActive={() => setActive(!active)}
        onClick={(props) => {
          logEvent("銷售線索", source, "選擇地區");
          setItem(props);
        }}
      >
        <div>
          <RegionItem
            size='small'
            data={regionData.list}
            onClick={(props) => {
              logEvent("銷售線索", source, "選擇地區");
              setItem(props);
              setActive(!active);
            }}
          />
        </div>
      </SelectItem>

      <header className={styles["header"]}>
        <h2 className={styles["header-title"]}>
          共找到<span className={styles["header-text"]}>{data.total}</span>個展示間
        </h2>
        <div>
          <Tag
            className={styles["tag-margi-left"]}
            arrow={true}
            selected={sort === "default"}
            onClick={() => {
              logEvent("銷售線索", source, "排序-綜合排序");
              setSort("default");
            }}
          >
            綜合排序
          </Tag>
          <Tag
            className={styles["tag-margi-left"]}
            arrow={true}
            selected={sort === "agent"}
            onClick={() => {
              logEvent("銷售線索", source, "排序-認證業代最多");
              setSort("agent");
            }}
          >
            認證業代最多
          </Tag>
          <Tag
            className={styles["tag-margi-left"]}
            arrow={true}
            selected={sort === "user"}
            onClick={() => {
              logEvent("銷售線索", source, "排序-服務用戶最多");
              setSort("user");
            }}
          >
            服務用戶最多
          </Tag>
        </div>
      </header>
      <div className={styles["content"]}>
        {Array.isArray(data.list) &&
          data.list.map((item, index) => (
            <Refresh
              key={index}
              refresh={() => {
                if (index == 0) {
                  logEvent("銷售線索（曝光）", source, "一鍵詢價");
                  logEvent("銷售線索（曝光）", source, "進入展示間");
                }
              }}
            >
              <ShowroomItem
                className={cx(styles["showroom-margin-bottom"], {
                  [styles["is-inquiry-none"]]: item.isInquiry === 0,
                })}
                name={item.name}
                fullAddress={`地址：${item.address}`}
                serviceMessage={item.serviceMessage}
                onInquiryClick={() => {
                  logEvent("銷售線索", source, "一鍵詢價");
                  window.open(
                    `https://c.8891.com.tw/ask/price?b=${window.brandId}&k=${window.kindId}&source=${source}`,
                    "_blank",
                  );
                }}
                onClick={() => {
                  logEvent("銷售線索", source, "進入展示間");
                  window.open(`https://c.8891.com.tw/agent/business/detial?id=${item.id}`, "_blank");
                }}
              />
            </Refresh>
          ))}
      </div>
    </section>
  );
};

export default Showroom;
